import { handleActions } from 'redux-actions';
import { setShowSuggestionModal, toggleShowSuggestionModal } from './actions';
const initialState = false;
const showSuggestionModalReducer = handleActions({
    [setShowSuggestionModal.toString()]: (_, { payload }) => payload,
    [toggleShowSuggestionModal.toString()]: state => !state
}, initialState);
export default showSuggestionModalReducer;
